import React, {useState} from 'react';
import { 
    Popover,
    Typography,
    Button,
    Grid,
    FormControlLabel,
    Checkbox,
    ListItemIcon,
} from '@material-ui/core/';

import ButtonClose from '../../buttonClose/.mixins/buttonClose';

let firstRender = true;
function TableColView({colunas, groups, onColumnUpdate }){
    
    const [anchorEl, setAnchorEl] = useState(null);
    const [isAllChecked, setIsAllChecked] = useState(true);
    const titleHeader = "MOSTRAR COLUNAS";

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
   
    const handleColChange = (element) => {
        element.options.display = !element.options.display;
        onColumnUpdate(colunas);
    };

    const handleAllColChange = () => {
        colunas.map((element, i)=>{
            if(element.options.viewColumns){
                element.options.display = !isAllChecked;
            }
        })
        setIsAllChecked(!isAllChecked);
        onColumnUpdate(colunas);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const HenderSubOptions = (element)=>{
        const result = colunas.reduce(function (acumulador, valor) {
            if(valor.options.viewColumns){
                const valueGroup = valor.group ? valor.group:99;
                acumulador[valueGroup] = acumulador[valueGroup] || [];
                acumulador[valueGroup].push(valor);
            }
            return acumulador;
        }, Object.create(null));

        return (
            <>
                {result[element.id] && <Typography variant="subtitle2">{element.label}</Typography> }
                <Grid container item xs={"auto"} spacing={1}>
                    {result[element.id] && result[element.id].map((element, i) => {
                        return (
                            <Grid item xs={3} key={i}>
                                <FormControlLabel
                                    key={i}
                                    label={element.label?element.label:element.name}
                                    control={
                                        <Checkbox
                                            checked={element.options.display}
                                            onChange={() => handleColChange(element)}
                                        />
                                    }
                                /> 
                            </Grid>
                        );
                    })}                    
                </Grid>
            </>
        )
    }
    
    const HenderOptions= ()=>{
        if (firstRender){
            groups.push({
                id: 99,
                label: "Outros",
            })
        }
        firstRender=false;
        return (
        <>
            {groups.map((element, i) => {
                return (

                    <HenderSubOptions {...element} key={i}/>
                );
            })}
        </>
        )
    };
    
    return (
        <div>
        <Button
            variant="outlined"
            color="primary"
            startIcon={
                <i className="material-icons">
                    view_week
                </i>
            }
            aria-describedby={id}
            onClick={handleClick}
        >
            {titleHeader}
        </Button>

        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            PaperProps={{
                style: {
                    width: '60%',
                    padding: '1%'
                },
            }}
        >   
            <Typography align={"center"} variant="subtitle2">
                {titleHeader}
                <ButtonClose closeMethod={handleClose}/>
            </Typography>
     
            <HenderOptions/>
            <Typography align={"center"}>
                <Button align="center" color="primary"  onClick={handleAllColChange}>
                    {isAllChecked ? "OCULTAR TODAS COLUNAS" : "VER TODAS COLUNAS"}
                </Button>
            </Typography>
        </Popover>
        </div>
    );
}

export default TableColView
